/**
 * User is logged in and has base details i.e. firstname and lastname
 */
const userHasBaseDetails = sessionProvider =>
	sessionProvider &&
	sessionProvider.provider &&
	sessionProvider.user &&
	sessionProvider.user.firstname &&
	sessionProvider.user.lastname;

export default userHasBaseDetails;



// WEBPACK FOOTER //
// ./src/user/userHasBaseDetails.js